import http from "@http"

//列表  不分页
export function getDefectTypeAll(data) {
    return http({
        url: '/lskj-data/api/data/defectType/all',
        method: "post",
        data
    })
}
//列表  分页
export function getDefectTypeList(data) {
    return http({
        url: '/lskj-data/api/data/defectType/list',
        method: "post",
        data
    })
}

//查询单条
export function defectTypeById(data) {
    return http({
        url: `/lskj-data/api/data/defectType/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function defectTypeAdd(data) {
    return http({
        url: '/lskj-data/api/data/defectType/add',
        method: "post",
        data
    })
}

//修改
export function updeteDefectType(data) {
    return http({
        url: `/lskj-data/api/data/defectType`,
        method: "put",
        data
    })
}
//删除
export function deleteDefectType(data) {
    return http({
        url: `/lskj-data/api/data/defectType?ids=${data.ids}`,
        method: "delete",
        data
    })
}